import { VariantProps, cva } from "class-variance-authority";
import * as React from "react";

import { cn } from "../../../utils";

const typographyVariants = cva("", {
  variants: {
    variant: {
      h1: "text-3xl lg:text-4xl block",
      h2: "text-3xl block",
      h3: "text-2xl block",
      h4: "text-xl block",
      h5: "text-lg block",
      h6: "text-md block",
      p: "text-sm block",
      small: "text-xs inline-block",
      article: "text-sm block",
      span: "text-sm inline",
    },
    affects: {
      lighter: "font-lighter",
      light: "font-light",
      default: "font-normal",
      medium: "font-medium",
      semiBold: "font-semibold",
      bold: "font-bold",
      extraBold: "font-extrabold",
      muted: "text-muted dark:text-muted-foreground",
    },
  },
  defaultVariants: {
    variant: "p",
    affects: "default",
  },
});

export type TTypographyProps = React.HTMLAttributes<HTMLHeadingElement> &
  VariantProps<typeof typographyVariants>;

const Typography = React.forwardRef<HTMLHeadingElement, TTypographyProps>(
  ({ className, variant, affects, ...props }, ref) => {
    const Comp =
      variant === "article"
        ? "div"
        : variant === "span"
          ? "span"
          : variant === "small"
            ? "span"
            : (variant ?? "p");
    return (
      <Comp
        className={cn(typographyVariants({ variant, affects, className }))}
        ref={ref}
        {...props}
      />
    );
  },
);
Typography.displayName = "Typography";

// eslint-disable-next-line react-refresh/only-export-components
export { Typography, typographyVariants };
